export interface SortBy {
	name: string;
	title: string;
	direction: SortByDirection;
}

export enum SortByDirection {
	Ascending = 'Ascending',
	Descending = 'Descending',
}
